import { defineStore } from 'pinia'
import { isEmpty } from "lodash";
import Vue from "vue";

export const useLoginStore = defineStore('login', {

    state: () => {
        return {

            /**
             * The loginMode will be filled by settings.ini, possible values: 'local' (default), 'ftp only', 'support'
             * possible values: 'local', 'ftp only', 'support'
             */
            loginMode: 'local',
            ftpServer: 'ftp.sheltercom.net',
            ftpUsername: '',
            ftpPassword: '',
            supportServer: 'ftp.sheltercom.net',
            supportUsername: '',
            supportPassword: '',
            supportStepTracker: 1,
            supportStep1Complete: false,
            supportStep2Complete: false,
            supportClients: [],
            supportChosenClient: '',
        }
    }

})
